import { StateUtils } from '@spartacus/core';
import {CustomStoreEntities} from "../../models/store-finder.model";

export const STORE_FINDER_FEATURE = 'stores';

export interface CustomStateWithStoreFinder {
  [STORE_FINDER_FEATURE]: CustomStoresState;
}

export interface CustomStoresState {
  findStores: StateUtils.LoaderState<CustomFindStoresState>;
}

export interface CustomFindStoresState {
  findStoresEntities: CustomStoreEntities;
}

